import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Seo } from "@/components/Seo";
import { getPost } from "@/content/blog";
import { company } from "@/content/site";
import NotFound from "./NotFound";

export default function BlogPost() {
  const { slug } = useParams();
  const post = slug ? getPost(slug) : undefined;
  if (!post) return <NotFound />;

  return (
    <>
      <Seo title={`${post.title} | ${company.name}`} description={post.excerpt} />
      {post.cover && (
        <div className="aspect-[16/10] w-full overflow-hidden bg-brand-900 sm:aspect-[21/9]">
          <img src={post.cover} alt="" className="h-full w-full object-cover" />
        </div>
      )}
      <article className="container max-w-prose py-16">
        <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-brand-600 hover:underline">
          <ArrowLeft className="h-4 w-4" /> All posts
        </Link>
        <p className="mt-6 text-xs text-brand-400">
          {new Date(post.date).toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </p>
        <h1 className="mt-1 text-3xl font-bold">{post.title}</h1>
        <div className="mt-6 space-y-4 text-brand-700">
          {post.body.map((p, i) =>
            p.startsWith("## ") ? (
              <h2 key={i} className="pt-4 text-xl font-bold text-brand-900">
                {p.slice(3)}
              </h2>
            ) : (
              <p key={i}>{p}</p>
            ),
          )}
        </div>
      </article>
    </>
  );
}
